import type { ErrorLike } from "@apollo/client";

import { useMemo } from "react";

import { useDeleteFolderMutation } from "@/graphql/folders/folders.hooks";

interface IUseDeleteFolderOptions {
  onCompleted?: () => void;
  onError?: () => void;
}

interface IUseDeleteFolderReturnedValue {
  deleteFolder: (input: { id: number }) => Promise<void>;
  error?: ErrorLike;
  loading: boolean;
}

function useDeleteFolder({
  onCompleted,
  onError,
}: IUseDeleteFolderOptions = {}): IUseDeleteFolderReturnedValue {
  const [deleteFolder, { error, loading }] = useDeleteFolderMutation({
    context: { errorType: "local" },
    onCompleted,
    onError,
  });

  return useMemo(
    () => ({
      deleteFolder: async ({ id }: { id: number }) => {
        await deleteFolder({
          variables: {
            id,
          },
        });
      },
      error,
      loading,
    }),
    [error, loading, deleteFolder]
  );
}

export default useDeleteFolder;
